/**
 * Advance to the next question after answering one 
 * on any QuizMaster quiz.
 */
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }

const updateProgressText = async (numberSpan, progress) => {
    let currentNumber = parseInt(numberSpan.innerText);
    while(currentNumber != progress) {
        currentNumber = (currentNumber < progress) ? currentNumber + 1 : currentNumber - 1;
        await sleep(10);
        numberSpan.innerText = currentNumber;
    }
}

const initProgressBar = (bar) => {
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: false, subtree: false };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'attributes') {
                if (mutation.attributeName === 'value') {
                    const max = parseInt(bar.getAttribute('max'));
                    const value = parseInt(bar.getAttribute('value'));
                    const progress = Math.round((value / max) * 100);
                    bar.style.width = `${progress}%`;
                    const numberSpan = bar.closest('.progress-wrapper').querySelector('.progress-percent');
                    if (numberSpan) {
                        setTimeout(() => {
                            updateProgressText(numberSpan, progress);
                        }, 50);
                    }
                }
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(bar, config);
}


const Quiz = () => {
    const quizQuestions = document.querySelectorAll('[data-step-type="question"]');
    quizQuestions.forEach((step) => {
        const continueButton = step.querySelector('[data-next]');
        // Hide continue button
        continueButton.classList.add('sr-only');
        // Submit for when 
        step.querySelectorAll('input').forEach((item) => {
            // use click rather than change so we can keep the same answer
            // when retaking the quiz
            item.addEventListener('click', () => {
                continueButton.click();
            });
        });
    });

    // Set observer for progress bar
    // Select the node that will be observed for mutations
    const progressBar = document.querySelector('[data-progress');
    if (progressBar) {
        initProgressBar(progressBar);
    }
};


export default Quiz;